import { testApi } from './landingPageTestApi';
import { FACE_FINDER_AVAILABLE } from './faceFinderAvailability';
// client/src/pages/lp/MobileLandingPage.js
import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiFetch } from '../../api/api';        // uses X-Org-Id if present
// import api from '../../api/index.js';            // your signed-url helper
import { getOrgMediaPath } from '../../utils/media/getOrgMediaPath';
import { SERVER_URL } from '../../constants/server-type';
import PhotoCropper from './PhotoCropper';
import { findPhotoFrame, PHOTO_GEOMETRY_VERSION } from './photoCropGeometry';
import usePhotoCamera from './usePhotoCamera';
import { loadLandingPageFonts } from './landingPageFonts';
import { toast } from 'react-toastify';

import './LandingPage.css';





const DEFAULT_PHOTO_CROP = { x: 0, y: 0, scale: 1 };

const MobileLandingPage = () => {
  useEffect(() => { loadLandingPageFonts(); }, []);
  const { landingPageId, gameId, clueNo } = useParams();  const navigate = useNavigate();
  const testMode = new URLSearchParams(window.location.search).get('test') === '1';
  const testOrgId = new URLSearchParams(window.location.search).get('orgId') || undefined;
  const [testReceipt,setTestReceipt] = useState(null);
  const [captureReceived,setCaptureReceived] = useState(false);
  const [testError,setTestError] = useState('');
  const testTransport=useMemo(()=>testApi(apiFetch,{enabled:testMode,actionId:landingPageId,orgId:testOrgId}),[testMode,landingPageId,testOrgId]);
  const captureApiFetch=async(path,options={})=>{
    try {
      const result=await testTransport(path,options);
      if(testMode && result?.submissionReceived)setTestReceipt(result.receiptId);
      if(!testMode && result?.submissionReceived)setCaptureReceived(true);
      return result;
    } catch(error) {
      if(testMode)setTestError(error.response?.status===401 ? 'Sign in with an Owner/Admin account, then reopen this test link.' : error.message);
      throw error;
    }
  };
  // for video capture
  const [recording, setRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const autoSubmitRef = useRef(false);
  const countdownIntervalRef = useRef(null);
  // resolved entities
  const [page, setPage] = useState(null);
  const [mediaConfig, setMediaConfig] = useState(null);
  const [action, setAction] = useState(null);
  const [secondsLeft, setSecondsLeft] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [cardDesign, setCardDesign] = useState(null);
  const [imgSize, setImgSize] = useState({ w: 0, h: 0 });
  // derived IDs
  const [orgId, setOrgId] = useState('');
  const [datasetId, setDatasetId] = useState('');
  const [dataDocId, setDataDocId] = useState(null);
  const [cardId, setCardId] = useState('');
  const [selectedCardDesign, setSelectedCardDesign] = useState(null);
  // const [selectedCardId, setSelectedCardId] = useState('');
  const [portraitCardDesign, setPortraitCardDesign] = useState(null);
  const [landscapeCardDesign, setLandscapeCardDesign] = useState(null);
  const [portraitCardDesignId, setPortraitCardDesignId] = useState('');
  const [landscapeCardDesignId, setLandscapeCardDesignId] = useState('');
  const [previewBlob, setPreviewBlob] = useState(null);
  const [gameContext, setGameContext] = useState(null);
  const [capturedIsPortrait, setCapturedIsPortrait] = useState(false);
  // UI / capture
  const [inputValues, setInputValues] = useState({});
  // capture session is the single source of truth
  // status: 'idle' | 'capturing' | 'uploading' | 'finalizing'
  const [captureSession, setCaptureSession] = useState({
    status: 'idle',
    mode: null,                 // 'photo' | 'video'
    flow: 'captureOnly',         // 'captureOnly' | 'captureAndSubmit' | 'captureSubmitAndReset'
    sessionId: 0,
    chosenCardId: null,
    isPortrait: null
  });
  const actionRef = useRef(null);
  const pageRef = useRef(null);
  const orgIdRef = useRef('');
  const datasetIdRef = useRef('');
  const cardIdRef = useRef('');
  const dataDocIdRef = useRef(null);
  const dragRef = useRef(null);
  const hasCameraStartedRef = useRef(false);
  const [previewAlign, setPreviewAlign] = useState({ x: 0, y: 0 });
  const [previewUrl, setPreviewUrl] = useState(null);

  const [autoSubmit, setAutoSubmit] = useState(false);
  const [cameraReady, setCameraReady] = useState(false);
  const videoRef = useRef(null);
  const hardStopTimerRef = useRef(null);
  const [imgKey, setImgKey] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [pageFade, setPageFade] = useState(false);
  const [cameraSessionId, setCameraSessionId] = useState(0);
  const [frameReady, setFrameReady] = useState(false);
  const [photoCrop, setPhotoCrop] = useState(DEFAULT_PHOTO_CROP);
  const photoCropRef = useRef(DEFAULT_PHOTO_CROP);
  const [photoCropReady, setPhotoCropReady] = useState(false);
  const photoCropReadyRef = useRef(false);
  const handleCropReadyChange = useCallback(ready => {
    photoCropReadyRef.current = ready;
    setPhotoCropReady(ready);
  }, []);
  const confirmInFlightRef = useRef(false);
  const cleaningUpRef = useRef(false);
  const [facingMode, setFacingMode] = useState("environment");
  const onPhotoCameraReady = useCallback(ready => {
    setCameraReady(ready);
    setFrameReady(ready);
  }, []);
  const stopPhotoCamera = usePhotoCamera({
    active: captureSession.mode === 'photo' && captureSession.status === 'capturing',
    sessionId: captureSession.sessionId,
    facingMode,
    quality: captureSession.captureQuality,
    videoRef,
    onReady: onPhotoCameraReady
  });

  const clearPhotoPreview = useCallback(() => {
    photoCropReadyRef.current = false;
    setPhotoCropReady(false);
    photoCropRef.current = DEFAULT_PHOTO_CROP;
    setPhotoCrop(DEFAULT_PHOTO_CROP);
    setPreviewBlob(null);
    setPreviewUrl(null);
    setSelectedCardDesign(null);
    setCapturedIsPortrait(false);
  }, []);

  // ---------- helpers ----------
  const getJpegQuality = () =>
   captureSession.captureQuality === 'hd' ? 0.98 : 0.85;

  const getBindKey = (block, index) => {
    const c = block?.config || {};
    // console.log("c:", c)
    // prefer builder’s mapping, then legacy keys, then a stable fallback
    return c.fieldKey || c.fieldId || c.slot || `input_${index}`;
  };

  // ✅ wait until a real video frame exists (not just metadata)
  const waitForFirstFrame = (videoEl) => {
    return new Promise(resolve => {
      if (!videoEl) return resolve();

      // Modern browsers (Chrome, Safari iOS 16+, Edge)
      if ('requestVideoFrameCallback' in videoEl) {
        videoEl.requestVideoFrameCallback(() => resolve());
        return;
      }

      // Fallback (older Safari)
      const check = () => {
        if (videoEl.readyState >= 2 && videoEl.videoWidth > 0) {
          resolve();
        } else {
          requestAnimationFrame(check);
        }
      };
      check();
    });
  };

  const getCardAspect = (cardSettings) => {
    if (!cardSettings) return 1.586;

    const base = 3.375 / 2.125; // CR80 landscape

    if (cardSettings.format === 'portrait') {
      return 1 / base;
    }

    return base;
  };

  const getPhotoFrameAspect = () => {
    if (!cardDesign?.capturePhotoBinding && !cardDesign?.objectsFront?.length) {
      return 3.375 / 2.125; // fallback CR80 landscape
    }

    // First photo frame in z-order
    const photoObj = findPhotoFrame(cardDesign);

    if (!photoObj || !photoObj.width || !photoObj.height) {
      return 3.375 / 2.125;
    }

    return photoObj.width / photoObj.height;
  };


  // keep refs in sync with latest state
  useEffect(() => { actionRef.current = action; }, [action]);
  useEffect(() => { pageRef.current = page; }, [page]);
  useEffect(() => { orgIdRef.current = orgId; }, [orgId]);
  useEffect(() => { datasetIdRef.current = datasetId; }, [datasetId]);
  useEffect(() => { cardIdRef.current = cardId; }, [cardId]);
  useEffect(() => { dataDocIdRef.current = dataDocId; }, [dataDocId]);

  useEffect(() => {
    if (!previewBlob) {
      setPreviewUrl(null);
      return;
    }

    const url = URL.createObjectURL(previewBlob);
    setPreviewUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [previewBlob]);

  useEffect(() => {
    if (!gameId || !clueNo) return;

    async function loadGame() {
      try {
        const game = await captureApiFetch(`/api/scavenger/item/${gameId}`);

        const clue = game?.clues?.find(
          c => c.clueNo === Number(clueNo)
        );

        if (!clue) {
          console.warn('[SCAVENGER] clue not found', clueNo);
        }

        setGameContext({
          gameId,
          clueNo: Number(clueNo),
          clue,
          game
        });

        console.log('[SCAVENGER] context loaded', {
          gameId,
          clueNo,
          clue
        });

      } catch (err) {
        console.error('[SCAVENGER] failed to load game', err);
      }
    }

    loadGame();
  }, [gameId, clueNo]);

  const mediaOptions = page?.mediaConfig || null;

  // Build { fld1:"...", fld2:"...", ... } from mapped INPUT blocks
  const buildFieldsFromBlocks = () => {
    const out = {};
    (page?.blocks || []).forEach((b, idx) => {
      if (b?.type === 'input') {
        const key = getBindKey(b, idx);
        if (!key) return;
        // use exactly the bind key (often "fld1"), renderer will look up by this
        out[key] = inputValues[key] ?? '';
      }
    });
    return out;
  };



  // Always pull the latest action settings before submitting (avoids stale printers, etc.)
  async function fetchActionFresh(actionId) {
    if (!actionId) return null;
    const res = await captureApiFetch(`/public/actions/${encodeURIComponent(actionId)}?t=${Date.now()}`, { method: 'GET' });
    return res?.action || res || null;
  }

     // ---------- simplest media pipeline ----------
     const cleanupRecording = useCallback(() => {
       stopPhotoCamera();
       if (cleaningUpRef.current) return;
       cleaningUpRef.current = true;

       console.log('[CLEANUP] cleanupRecording start');

       try {
         if (hardStopTimerRef.current) {
           clearTimeout(hardStopTimerRef.current);
           hardStopTimerRef.current = null;
         }
         if (countdownIntervalRef.current) {
           clearInterval(countdownIntervalRef.current);
           countdownIntervalRef.current = null;
         }

         const stream = videoRef.current?.srcObject;
         if (stream) {
           stream.getTracks().forEach(track => {
             console.log('[CLEANUP] stopping track', track.kind, track.readyState);
             track.stop();
           });
           videoRef.current.srcObject = null;
         }
       } catch (err) {
         console.warn('[CLEANUP] error', err);
       }

       mediaRecorderRef.current = null;
       setRecording(false);
       setCameraReady(false);
       // setCapturing(false);
       setSecondsLeft(null);

       console.log('[CLEANUP] cleanupRecording complete');
       cleaningUpRef.current = false;
     }, [stopPhotoCamera]);

     const resetSession = useCallback(() => {
       cleanupRecording();
       clearPhotoPreview();
       console.log('[SESSION] reset');

       setDataDocId(null);
       dataDocIdRef.current = null; // important: clear ref too

       setInputValues({});          // clear form fields
       setRecording(false);
       setSecondsLeft(null);

       setCameraReady(false);
       setFrameReady(false);

       // bump session id to force <video> remount
       setCaptureSession(s => ({
         status: 'idle',
         mode: null,
         flow: 'captureOnly',
         sessionId: s.sessionId + 1
       }));
     }, [cleanupRecording, clearPhotoPreview]);



     function putToS3(uploadUrl, blob, mimeType, onProgress) {
       return new Promise((resolve, reject) => {
         const xhr = new XMLHttpRequest();
         xhr.open('PUT', uploadUrl);

         xhr.setRequestHeader('Content-Type', mimeType);
         // xhr.setRequestHeader('x-amz-acl', 'public-read');

         xhr.upload.onprogress = (e) => {
           if (!e.lengthComputable) return;
           const pct = Math.round((e.loaded / e.total) * 100);
           onProgress?.(pct);
         };

         xhr.onload = () =>
           (xhr.status >= 200 && xhr.status < 300)
             ? resolve()
             : reject(new Error(`PUT failed ${xhr.status}`));

         xhr.onerror = () => reject(new Error('PUT failed'));

         xhr.send(blob);
       });
     }

     function getSelectedCardId(isPortrait) {

       return isPortrait
         ? (portraitCardDesignId || cardId)
         : (landscapeCardDesignId || cardId);

     }

     const ensureDataDoc = async (chosenCardId) => {
       // always prefer the ref (avoids stale closure)
       if (dataDocIdRef.current) return dataDocIdRef.current;

       const a = actionRef.current;
       const p = pageRef.current;

       const fields = buildFieldsFromBlocks();
       const dsId = a?.datasetId || a?.dataSetId || datasetIdRef.current;
       const org = orgIdRef.current;

       if (!testMode && actionRef.current?.printMode !== 'none' && !chosenCardId && !cardIdRef.current) {
         throw new Error('cardId missing');
       }
       if (!dsId) throw new Error('datasetId missing');
       if (!org) throw new Error('orgId missing');

       var payload = {
         orgId: org,
         ...(a?.printMode === 'none' ? {captureOnlyActionId:a._id} : {}),
         datasetId: dsId,
         templateId: p?.templateId || null,
         landingPageId: p?._id,
         fields,
         // 🔥 SCAVENGER CONTEXT
         gameId: gameContext?.gameId || null,
         clueNo: gameContext?.clueNo || null
       };

       if (chosenCardId)
       {
         payload.cardId = chosenCardId;
       }

       const saved = await captureApiFetch(`/datadoc/adddatadoc`, {
         method: 'POST',
         body: payload
       });


       setDataDocId(saved._id);
       dataDocIdRef.current = saved._id;

       return saved._id;
     };


     const getUploadUrl = async ({ type, fileName, mimeType, dataDocId }) => {
       const dsId = action?.datasetId || action?.dataSetId || datasetId;
       const res = await captureApiFetch('/media/public-upload-url', {
         method: 'POST',
         body: {
           scope: 'dataset',
           orgId,
           datasetId: dsId,
           dataDocId,
           type,
           fileName,
           originalName: fileName,
           mimeType
         }
       });
       return res;
     };

     const attachMediaToDataDoc = async ({ dataDocId, type, bucket, key, duration, crop }) => {
       const res = await captureApiFetch(`/datadoc/attach-media`, {
         method: 'POST',
         body: {
           dataDocId,
           type,           // 'photo' | 'video'
           s3Bucket: bucket,
           s3Key: key,
           duration,
           ...(type === 'photo' ? { captureGeometryVersion: PHOTO_GEOMETRY_VERSION } : {}),
           crop: type === 'photo' ? photoCropRef.current : photoCrop
         }
       });
       return res;
     };

     const lockingRef = useRef(false);

     const lockDataDoc = async (docId) => {
       if (lockingRef.current) return;
       lockingRef.current = true;
       try {
         const res = await captureApiFetch(`/datadoc/lock`, {
           method: 'POST',
           body: {
             dataDocId: docId,
             fields:buildFieldsFromBlocks(),
             orgId,
             actionId: action._id
           }
         });


       } finally {
          lockingRef.current = false;
        }
     };

     const captureAndUploadPhoto = async () => {
       const video = videoRef.current;
       if (!video) throw new Error('video missing');
       if (!cameraReady || !frameReady) throw new Error('camera not ready');

       if (video.videoWidth === 0 || video.videoHeight === 0) {
         throw new Error('video dimensions not ready');
       }

       const canvas = document.createElement('canvas');
       canvas.width = video.videoWidth;
       canvas.height = video.videoHeight;
       const isPortrait = canvas.height > canvas.width;
       const chosenCardId = getSelectedCardId(isPortrait);

       const ctx = canvas.getContext('2d');
       ctx.drawImage(video, 0, 0);

       const blob = await new Promise(resolve =>
         canvas.toBlob(resolve, 'image/jpeg', getJpegQuality(), 0.92)
       );

       if (!blob || blob.size < 15000) {
         throw new Error(`invalid blob ${blob?.size}`);
       }

       setUploading(true);
       setUploadProgress(0);

       try {
         const docId = await ensureDataDoc(chosenCardId);

         const meta = await getUploadUrl({
           type: 'photo',
           fileName: `photo_${Date.now()}.jpg`,
           mimeType: 'image/jpeg',
           dataDocId: docId
         });

         await putToS3(meta.uploadUrl, blob, 'image/jpeg', setUploadProgress);

         await attachMediaToDataDoc({
           dataDocId: docId,
           type: 'photo',
           bucket: meta.bucket,
           key: meta.key
         });

         return docId;
       } finally {
         setUploading(false);
         setUploadProgress(0);
       }
     };

     // PHOTO: capture from video tag -> upload -> attach to doc (overwrite) -> optionally lock
     const handleCapturePhoto = async () => {

       if (!videoRef.current || !cameraReady || !frameReady) return;

       const video = videoRef.current;
       if (video.videoWidth === 0 || video.videoHeight === 0) {
         console.warn('[CAPTURE] video dimensions not ready');
         return;
       }


       if (
         !video.videoWidth ||
         !video.videoHeight
       ) {
         alert('Camera not ready yet');
         return;
       }



       // --- capture ---
       const canvas = document.createElement('canvas');
       canvas.width = video.videoWidth;
       canvas.height = video.videoHeight;

       const isPortrait = canvas.height > canvas.width;
       const chosenCardId = getSelectedCardId(isPortrait);

       const chosenDesign =
         isPortrait
           ? (portraitCardDesign || cardDesign)
           : (landscapeCardDesign || cardDesign);
       setSelectedCardDesign(chosenDesign);

       const ctx = canvas.getContext('2d');
       ctx.drawImage(video, 0, 0);


       const blob = await new Promise(resolve =>
         canvas.toBlob(resolve, 'image/jpeg', getJpegQuality(), 0.92)
       );

       if (!blob || blob.size < 15000) {
         console.warn('[CAPTURE] invalid blob', blob?.size);
         return;
       }

       setUploading(true);
       setUploadProgress(0);

       try {
         const dataDocId = await ensureDataDoc(chosenCardId);
         const meta = await getUploadUrl({
           type: 'photo',
           fileName: `photo_${Date.now()}.jpg`,
           mimeType: 'image/jpeg',
           dataDocId
         });

         await putToS3(meta.uploadUrl, blob, 'image/jpeg', setUploadProgress);

         await attachMediaToDataDoc({
           dataDocId,
           type: 'photo',
           bucket: meta.bucket,
           key: meta.key
         });
         // ✅ AUTO-SUBMIT if enabled
         if (autoSubmitRef.current) {
           // setDataDocId(null);            // ✅ IMPORTANT: new session next time
           autoSubmitRef.current = false; // ✅ prevent accidental carryover
         }

       } finally {
         setUploading(false);
         setUploadProgress(0);

         // ✅ cleanup ONLY here
         cleanupRecording();
       }
     };


     const handleFinalize = async () => {
       if (!dataDocId) {
         console.warn('No DataDoc to finalize');
         return;
       }

       const res = await captureApiFetch(`/datadoc/finalize`, {
         method: 'POST',
         body: {
           orgId,
           dataDocId,
           actionId: action._id
         }
       });

       if (!res.ok) {
         alert(await res.text());
         return;
       }

       // setDataDocId(null); // lifecycle complete
     };


  // ---------- camera ----------
  useEffect(() => {
    let stream;

    // Still photos have a cancellable stream owner; preserve the video path.
    if (captureSession.mode === 'photo') return;

    if (captureSession.status !== 'capturing') {
      // 🛑 ensure camera shuts down when leaving capture mode
      // cleanupRecording();
      return;
    }

    const mode = captureSession.mode;
    const runCamera = async () => {
      if (!videoRef.current) return;
      if (videoRef.current?.srcObject) {
        console.log('[CAMERA] stream already exists; skipping getUserMedia');
        return;
      }
      console.log('[CAMERA] requesting getUserMedia…');

      const isHD = captureSession.captureQuality === 'hd';
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: isHD
            ? {
                width: { ideal: 1920 },
                height: { ideal: 1080 },
                facingMode: { ideal: facingMode }
              }
            : {
                width: { ideal: 1280 },
                height: { ideal: 720 },
                facingMode: { ideal: facingMode }
              },
          audio: mode === 'video'
        });
      } catch (err) {
        console.warn('[CAMERA] HD failed, fallback to standard');

        stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 1280 },
            height: { ideal: 720 },
            facingMode: 'user'
          },
          audio: mode === 'video'
        });
      }

      console.log('[CAMERA] stream acquired', {
        tracks: stream.getTracks().map(t => ({
          kind: t.kind,
          readyState: t.readyState
        }))
      });

      videoRef.current.srcObject = stream;

      videoRef.current.onloadeddata = () => {
        const video = videoRef.current;
        if (!video) return;
        console.log('[CAMERA RESOLUTION]', {
          width: video.videoWidth,
          height: video.videoHeight,
          mode: captureSession.captureQuality
        });

        // Wait for an actual decoded frame
        if ('requestVideoFrameCallback' in video) {
          video.requestVideoFrameCallback(() => {
            setCameraReady(true);
            setFrameReady(true);
            console.log('[CAMERA] first real frame ready');
          });
        } else {
          // Safari fallback
          const check = () => {
            if (video.videoWidth > 0 && video.videoHeight > 0) {
              setCameraReady(true);
              setFrameReady(true);
            } else {
              requestAnimationFrame(check);
            }
          };
          check();
        }
      };

    };

    runCamera();

    // 🚫 NO TRACK STOPPING HERE
    return () => {
      console.log('[CAMERA] effect cleanup (no-op)');
      // cleanupRecording();

    };
  }, [captureSession.status, captureSession.mode, captureSession.sessionId]);


  const captureInFlightRef = useRef(false);

  const runCaptureFlow = async () => {
    if (captureInFlightRef.current) return;
    captureInFlightRef.current = true;

    try {
      const { mode } = captureSession;

      if (mode !== 'photo') return;

      if (!videoRef.current || !cameraReady || !frameReady) return;

      const video = videoRef.current;

      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const isPortrait =
        canvas.height > canvas.width;

      const chosenCardId =
        getSelectedCardId(isPortrait);

      const chosenDesign =
        isPortrait
          ? (portraitCardDesign || cardDesign)
          : (landscapeCardDesign || cardDesign);

      console.log('[CAPTURE]', {
        isPortrait,
        chosenCardId
      });

      setSelectedCardDesign(chosenDesign);
      setCapturedIsPortrait(isPortrait);

      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0);

      const blob = await new Promise(resolve =>
        canvas.toBlob(resolve, 'image/jpeg', getJpegQuality(), 0.92)
      );

      if (!blob || blob.size < 15000) {
        console.warn('Invalid blob');
        return;
      }

      // 🔥 STOP CAMERA NOW
      cleanupRecording();
      // 🔥 SWITCH TO PREVIEW MODE
      setCaptureSession(s => ({
        ...s,
        status: 'preview',
        chosenCardId,
        isPortrait
      }));

      // 🔥 STORE PREVIEW
      setPreviewBlob(blob);

      // // 🔥 SWITCH TO PREVIEW MODE
      // setCaptureSession(s => ({
      //   ...s,
      //   status: 'preview'
      // }));

    } catch (err) {
      console.error('[FLOW] capture failed:', err);
      cleanupRecording();
      setCaptureSession(s => ({ ...s, status: 'idle' }));
    } finally {
      captureInFlightRef.current = false;
    }
  };


  const choosePhoto = async event => {
    const file = event.target.files?.[0]; event.target.value = '';
    if (!file || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) { if (file) toast.error('Choose a JPEG, PNG or WebP photo.'); return; }
    const url = URL.createObjectURL(file), img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const isPortrait = img.naturalHeight > img.naturalWidth;
      const chosenCardId = getSelectedCardId(isPortrait);
      setSelectedCardDesign(isPortrait ? (portraitCardDesign || cardDesign) : (landscapeCardDesign || cardDesign));
      setCapturedIsPortrait(isPortrait); cleanupRecording();
      setCaptureSession(s => ({...s, status: 'preview', chosenCardId, isPortrait}));
      setPreviewBlob(file);
    };
    img.onerror = () => {URL.revokeObjectURL(url); toast.error('Photo could not be opened. Choose another photo.');};
    img.src = url;
  };

  const photoNeedsPositioning = (!testMode && action?.printMode !== 'none') || !!findPhotoFrame(selectedCardDesign);
  const confirmPreview = async () => {
    if (confirmInFlightRef.current || captureSession.status !== 'preview') return;
    if (captureSession.mode === 'photo' && photoNeedsPositioning && !photoCropReadyRef.current) return;

    if (!previewBlob || previewBlob.size === 0) {
      console.error("Invalid preview blob:", previewBlob?.size);
      alert("Photo capture failed. Please retake the photo.");
      return;
    }

    confirmInFlightRef.current = true;
    try {
      setCaptureSession(s => ({ ...s, status: 'uploading' }));
      setUploading(true);
      setUploadProgress(0);
      const docId =
        await ensureDataDoc(
          captureSession.chosenCardId
        );

      const meta = await getUploadUrl({
        type: 'photo',
        fileName: `photo_${Date.now()}.${previewBlob.type === 'image/png' ? 'png' : previewBlob.type === 'image/webp' ? 'webp' : 'jpg'}`,
        mimeType: previewBlob.type || 'image/jpeg',
        dataDocId: docId
      });

      await putToS3(meta.uploadUrl, previewBlob, previewBlob.type || "image/jpeg", setUploadProgress);
      await attachMediaToDataDoc({
        dataDocId: docId,
        type: 'photo',
        bucket: meta.bucket,
        key: meta.key,
        crop: photoCropRef.current
      });

      const { flow } = captureSession;

      if (flow === 'captureOnly') {

        clearPhotoPreview();

        setCaptureSession(s => ({
          ...s,
          status: 'idle'
        }));
      }

      else if (flow === 'captureAndSubmit') {

        setCaptureSession(s => ({
          ...s,
          status: 'finalizing'
        }));

        await lockDataDoc(docId);

        clearPhotoPreview();
      }

      else if (flow === 'captureSubmitAndReset') {

        setCaptureSession(s => ({
          ...s,
          status: 'finalizing'
        }));

        await lockDataDoc(docId);

        setPreviewBlob(null);

        resetSession();

        setCurrentStep(1);
      }

    } catch (err) {

      console.error("Upload failed:", err);
      setCaptureSession(s => ({ ...s, status: 'idle' }));

    } finally {

      confirmInFlightRef.current = false;
      setUploading(false);
      setUploadProgress(0);
    }
  };


  const retakePhoto = () => {
    if (confirmInFlightRef.current) return;
    clearPhotoPreview();
    setCameraReady(false);
    setFrameReady(false);

    setCaptureSession(s => ({
      ...s,
      status: 'capturing',
      mode: s.mode,
      flow: s.flow,
      sessionId: s.sessionId + 1,
      chosenCardId: null,
      isPortrait: null
    }));
  };

  // ---------- resolve Action → LandingPage (fallback: LandingPage → active Action) ----------
  useEffect(() => {
    let mounted = true;
    resetSession();
    setTestReceipt(null);setTestError('');setCaptureReceived(false);
    setCardDesign(null);
    setPortraitCardDesign(null);
    setLandscapeCardDesign(null);
    setPortraitCardDesignId('');
    setLandscapeCardDesignId('');

    // 🔑 HARD RESET for every page visit / refresh
    // setCapturing(false);
    setCameraReady(false);
    setFrameReady(false);
    setRecording(false);
    setSecondsLeft(null);
    setInputValues({});
    setCurrentStep(1);

    // 🔑 THIS is the missing piece
    setCameraSessionId(id => id + 1);
    setCapturedIsPortrait(false);
    setPreviewUrl('');
    setSelectedCardDesign(null);
    // setSelectedCardId('');

    // also defensively stop any orphaned stream
    try {
      const stream = videoRef.current?.srcObject;
      if (stream) {
        stream.getTracks().forEach(t => t.stop());
        videoRef.current.srcObject = null;
      }
    } catch {}

    (async () => {
      try {
        // 1) Try treat :id as an Action ID
        try {
          const res = await captureApiFetch(`/public/actions/${encodeURIComponent(landingPageId)}`, { method: 'GET' });

          const a = res?.action || res; // allow either {action, landingPage} or flat action
          const lp = res?.landingPage || res?.page;
          const mC = res?.mediaConfig || null;

          if (!a || !lp) throw new Error('Incomplete action payload');

          if (!mounted) return;
          setAction(a);
          setPage(lp);
          setMediaConfig(mC);
          setOrgId(a.orgId || lp?.orgId || '');
          setDatasetId(a.datasetId || (res?.dataset?._id ?? ''));
          setCardId(a.cardDesignId || a.cardId || res?.cardDesign?._id || '');
          if (a.cardDesignId || a.cardId) {
            const baseId = a.cardDesignId || a.cardId;

            try {
              const card = await captureApiFetch(
                `/cards/public/${baseId}`,
                { method: 'GET' }
              );

              setCardDesign(card);

            } catch (err) {
              console.error('Failed loading card design', baseId, err);
            }
          }
          if (a.landscapeCardDesignId) {

            setLandscapeCardDesignId(
              a.landscapeCardDesignId || ''
            );

            try {

              const landscape = await captureApiFetch(
                `/cards/public/${a.landscapeCardDesignId}`,
                { method: 'GET' }
              );

              console.log('landscape:', landscape);

              setLandscapeCardDesign(landscape);

            } catch (err) {

              console.error(
                'Failed loading landscape card',
                a.landscapeCardDesignId,
                err
              );
            }
          }
          if (a.portraitCardDesignId) {

            setPortraitCardDesignId(
              a.portraitCardDesignId || ''
            );

            try {

              const portrait = await captureApiFetch(
                `/cards/public/${a.portraitCardDesignId}`,
                { method: 'GET' }
              );

              console.log('portrait:', portrait);

              setPortraitCardDesign(portrait);

            } catch (err) {

              console.error(
                'Failed loading portrait card',
                a.portraitCardDesignId,
                err
              );
            }
          }
          // store selected printers for submission
          const selectedPrinters = Array.isArray(a.printerNames) ? a.printerNames : [];
          setInputValues(prev => ({ ...prev, __printers: selectedPrinters }));
          return; // ✅ done
        } catch (error) {
          if(testMode)throw error;
          // 2) Fallback: treat :id as Landing Page ID
          const lp = await captureApiFetch(`/public/landingpages/${encodeURIComponent(landingPageId)}`, { method: 'GET' });
          if (!mounted) return;
          setPage(lp);
          setMediaConfig(lp.mediaConfig);
          setOrgId(lp.orgId || '');

          // find ACTIVE action for this LP (public)
          try {
            const r = await captureApiFetch(`/public/actions/byLandingPage/${encodeURIComponent(landingPageId)}`, { method: 'GET' });
            const a = r?.action || null;
            console.log("a:",a)
            if (a) {
              setAction(a);
              setDatasetId(a.datasetId || '');
              setCardId(a.cardDesignId || a.cardId || '');
            }
          } catch {
            console.error('broke!!:');
          }
        }
      } catch (err) {
        console.error('Failed to resolve Action/LandingPage:', err);
        alert('This link is not valid or has expired.');
        navigate('/');
      }
    })();
    return () => { mounted = false; };
  }, [landingPageId, navigate, resetSession]);

  useEffect(() => {
    if (captureSession.mode === 'photo') return;
    if (captureSession.status !== 'capturing') return;

    const restart = async () => {
      const video = videoRef.current;
      if (!video) return;

      const old = video.srcObject;
      if (old) {
        old.getTracks().forEach(t => t.stop());
      }

      if (hasCameraStartedRef.current && videoRef.current?.srcObject) {
        console.log('[CAMERA] reusing existing stream');
        return;
      }


      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: facingMode },
          width: { ideal: 1280 },
          height: { ideal: 720 }
        },
        audio: false
      });

      video.srcObject = stream;
    };

    restart();

  }, [facingMode]);

  const toggleCamera = async () => {
    if (captureSession.mode === 'photo') {
      onPhotoCameraReady(false);
      setFacingMode(mode => mode === 'environment' ? 'user' : 'environment');
      return;
    }
    const video = videoRef.current;
    if (!video || !video.srcObject) return;

    const stream = video.srcObject;
    const track = stream.getVideoTracks()[0];

    const newFacing = facingMode === "environment" ? "user" : "environment";

    try {
      await track.applyConstraints({
        facingMode: { exact: newFacing }
      });
      setFacingMode(newFacing);
    } catch {
      // fallback → full restart ONLY if needed
      console.log('[CAMERA] fallback flip');

      stream.getTracks().forEach(t => t.stop());

      const newStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: newFacing },
        audio: false
      });

      video.srcObject = newStream;
      setFacingMode(newFacing);
    }
  };

  // VIDEO: record -> hard stop -> upload -> attach -> optionally lock
  const handleStartVideo = async () => {
    if (!videoRef.current) return;

    if (!mediaConfig?.allowVideo) {
      alert('Video capture is not allowed for this form.');
      return;
    }

    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: { ideal: facingMode }
      },
      audio: false
    });
    videoRef.current.srcObject = stream;
    await videoRef.current.play();

    const recorder = new MediaRecorder(stream, { mimeType: 'video/webm' });
    const chunks = [];

    recorder.onstart = () => console.log('[RECORDER] start');

    recorder.ondataavailable = e => {
      console.log('[RECORDER] data', e.data?.size)
      if (e.data?.size) chunks.push(e.data);
    };

    // recorder.ondataavailable = (e) => {
    //   if (e.data?.size) chunks.push(e.data);
    // };

    recorder.onstop = async () => {
      console.log('[RECORDER] stop')
      if (uploading) return;

      const blob = await new Blob(chunks, { type: 'video/webm' });
      cleanupRecording();

      setUploading(true);
      setUploadProgress(0);

      try {
        const dataDocId = await ensureDataDoc(null);
        const meta = await getUploadUrl({
          type: 'video',
          fileName: `video_${Date.now()}.webm`,
          mimeType: 'video/webm',
          dataDocId
        });
        setImgKey(meta.key);

        await putToS3(meta.uploadUrl, blob, 'video/webm', setUploadProgress);
        await attachMediaToDataDoc({ dataDocId, type: 'video', bucket: meta.bucket, key: meta.key, duration: Math.round(blob.size / 1000) });
      } catch (err) {
        console.error('Video upload failed:', err);
        alert('Video upload failed.');
      } finally {
        setUploading(false);
        setUploadProgress(0);
        cleanupRecording();
      }
    };

    mediaRecorderRef.current = recorder;
    setRecording(true);
    recorder.start();

    // HARD STOP countdown (admin-controlled)
    const maxSeconds = Number(mediaConfig?.maxVideoSeconds) || 0;
    if (maxSeconds > 0) {
      setSecondsLeft(maxSeconds);

      countdownIntervalRef.current = setInterval(() => {
        setSecondsLeft((s) => {
          if (s === null) return null;
          if (s <= 1) return 0;
          return s - 1;
        });
      }, 1000);

      hardStopTimerRef.current = setTimeout(() => {
        try {
          if (mediaRecorderRef.current?.state === 'recording') {
            mediaRecorderRef.current.stop();
          }
        } catch {}
      }, maxSeconds * 1000);
    }
  };

  const handleStopVideo = () => {
    try {
      if (mediaRecorderRef.current?.state === 'recording') {
        mediaRecorderRef.current.stop();
      }
    } catch {}
  };


  const handleInputChange = (fieldId, value) => {
    setInputValues(prev => ({ ...prev, [fieldId]: value }));
  };

  const handleTakePhoto = async () => {
    const video = videoRef.current;
    if (!video) return;

    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const isPortrait = canvas.height > canvas.width;
    const chosenCardId = getSelectedCardId(isPortrait);

    canvas.getContext('2d').drawImage(video, 0, 0);

    const blob = await new Promise(resolve =>
      canvas.toBlob(resolve, 'image/jpeg', getJpegQuality(), 0.92)
    );

    setUploading(true);
    setUploadProgress(0);

    try {
      const docId = await ensureDataDoc(chosenCardId);

      const meta = await getUploadUrl({
        type: 'photo',
        fileName: `photo_${Date.now()}.jpg`,
        mimeType: 'image/jpeg',
        dataDocId: docId
      });

      await putToS3(meta.uploadUrl, blob, 'image/jpeg', setUploadProgress);

      await attachMediaToDataDoc({
        dataDocId: docId,
        type: 'photo',
        bucket: meta.bucket,
        key: meta.key
      });

      // ❗ DO NOT SUBMIT HERE
      // overwrite-only behavior
    } finally {
      setUploading(false);
      setUploadProgress(0);
      cleanupRecording();
    }
  };

  const handleCapturePhotoInternal = async () => {
    if (!videoRef.current || !cameraReady || !frameReady) return;

    const video = videoRef.current;

    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const isPortrait = canvas.height > canvas.width;
    const chosenCardId = getSelectedCardId(isPortrait);

    if (video.videoWidth === 0 || video.videoHeight === 0) {
      console.warn('[CAPTURE] video dimensions not ready');
      return;
    }
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0);

    const blob = await new Promise(resolve =>
      canvas.toBlob(resolve, 'image/jpeg', getJpegQuality(), 0.92)
    );


    if (!blob || blob.size < 15000) {
      console.warn('[CAPTURE] invalid blob');
      return;
    }

    const dataDocId = await ensureDataDoc(chosenCardId);

    const meta = await getUploadUrl({
      type: 'photo',
      fileName: `photo_${Date.now()}.jpg`,
      mimeType: 'image/jpeg',
      dataDocId
    });

    await putToS3(meta.uploadUrl, blob, 'image/jpeg', setUploadProgress);

    await attachMediaToDataDoc({
      dataDocId,
      type: 'photo',
      bucket: meta.bucket,
      key: meta.key
    });
    // if (autoSubmitRef.current) {
      autoSubmitRef.current = false;
      // navigate(`/lp/${id}`)
    // }

    cleanupRecording();
    setCurrentStep(1);
    return dataDocId;
  };


  // ---------- upload + submit ----------
  const handleCaptureSubmitAndReset = async () => {
    try {
      const docId = await handleCapturePhotoInternal();

      if (!docId) return;



    } catch (err) {
      console.error('Capture+Submit failed:', err);
    }
  };


  const handleTakePhotoAndSubmit = async () => {
    await handleCapturePhoto();
    const docId = dataDocId;
    if (!docId) return;


    // 🔑 now and only now
    // setDataDocId(null);
  };

  const normalizeActionType = (type) => {
    if (type === 'goto') return 'navigateStep';
    return type;
  };

  const handleCropChange = (crop) => {
    photoCropRef.current = crop;
    setPhotoCrop(crop);
  };

  const handleAction = async (actionType, linkUrl, blockConfig = {}) => {
    if (confirmInFlightRef.current) return;

    switch (actionType) {
      case 'capture': {
          clearPhotoPreview();
          const mode = blockConfig.captureMode || 'photo';
          const quality = blockConfig.captureQuality || 'standard';
          const flow = blockConfig.flow || 'captureOnly';
          // start the session
          setCameraReady(false);
          setFrameReady(false);

          setCaptureSession(s => ({
           status: 'capturing',
           mode,
           flow,
           captureQuality: quality,
           faceFinder: blockConfig.faceFinder === true,
           sessionId: s.sessionId + 1   // force video remount every time capture starts
          }));

          break;
       }


        case 'submit': {
          if(testMode || action?.printMode === 'none') {
            const docId=await ensureDataDoc(null);
            await captureApiFetch('/datadoc/lock',{method:'POST',body:{dataDocId:docId,orgId,actionId:action._id,fields:buildFieldsFromBlocks()}});
            return;
          }
          if (!dataDocId) {
            console.warn('No DataDoc to submit');
            return;
          }
          await captureApiFetch(`/datadoc/lock`, {
            method: 'POST',
            body: {
              orgId,
              dataDocId,
              actionId: action._id
            }
          });
          break;
        }

      case 'navigateStep': {
        cleanupRecording(); // 🔑 stop camera if user navigates

        const next = Number(blockConfig?.nextStep);
        if (!next) return;

        setPageFade(true);
        setTimeout(() => {
          setCurrentStep(next);
          setPageFade(false);
        }, 150);
        break;
      }


      case 'navigate':
        if (linkUrl) window.location.href = linkUrl;
        break;

      case 'reset':
        resetSession();
        setCurrentStep(1);
        break;
    }
  };



  const renderBlock = (block, index) => {
    const { type, config } = block;

    const {
      label,
      color = '#000',
      backgroundColor = 'transparent',
      font = 'Arial',
      size = '16',
      bold,
      italic,
      underline,
      align = 'left',
      url,
      fieldColor,
      fieldBgColor,
      placeholder,
      linkUrl
    } = config;

    // ✅ normalize action field (builder uses actionType)
    const actionType =
      config.actionType ||   // NEW (builder)
      config.action ||       // legacy
      null;


    const style = {
      fontFamily: font,
      fontSize: `${size}px`,
      fontWeight: bold ? 'bold' : 'normal',
      fontStyle: italic ? 'italic' : 'normal',
      textDecoration: underline ? 'underline' : 'none',
      color,
      backgroundColor,
      textAlign: align,
      width: '100%',
      whiteSpace: 'pre-wrap',
      padding: '5px',
      boxSizing: 'border-box'
    };

    switch (type) {
      case 'text':
        return (
          <div key={index} className="blockPreview" style={{ whiteSpace: 'pre-wrap' }}>
            <div dangerouslySetInnerHTML={{ __html: config.text || '' }} />
          </div>
        );
        case 'image': {
          const resolvedUrl = url;   // you already confirmed this works
          const thumbnailUrl = getOrgMediaPath(config.thumbnailUrl);

          return (
            <div
              key={index}
              className="blockPreview"
              style={{ textAlign: align || 'left', marginTop: 10 }}
            >
              {config.mediaType === 'video' ? (
                <video
                  src={resolvedUrl}
                  poster={thumbnailUrl}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="auto"
                  style={{
                    width: config.size || '100%',
                    height: 'auto',
                    borderRadius: '6px',
                    background: '#000'
                  }}
                />
              ) : (
                <img
                  src={resolvedUrl}
                  alt=""
                  style={{
                    width: config.size || '100%',
                    height: 'auto'
                  }}
                />
              )}
            </div>
          );
        }

      case 'input': {
        const { fieldBackgroundColor } = config;
        const bindKey = getBindKey(block, index);
        return (
          <div key={index} className="blockPreview" style={{ marginBottom: 10 }}>
            {label && <div style={style}>{label}</div>}
            <input
              type="text"
              placeholder={placeholder || ''}
              value={inputValues[bindKey] || ''}
              onChange={(e) => handleInputChange(bindKey, e.target.value)}
              style={{
                ...style,
                color: fieldColor || '#000',
                backgroundColor: fieldBackgroundColor ?? fieldBgColor ?? '#fff',
              }}
            />
          </div>
        );
      }
      case 'button':
        // console.log('[MOBILE BTN]', {
        //   actionType,
        //   normalized: normalizeActionType(actionType),
        //   nextStep: config.nextStep,
        //   config
        // });
        const buttonAlign = config.align || 'center';
        return (
          <div
            key={index}
            className="blockPreview"
            style={{
              display: 'flex',
              justifyContent:
                buttonAlign === 'right'
                  ? 'flex-end'
                  : buttonAlign === 'left'
                  ? 'flex-start'
                  : 'center',
              marginTop: 10
            }}
          >
            <button
              style={{
                color: (config.color ?? '#ffffff'),
                backgroundColor: (config.backgroundColor ?? '#007bff'),
                border: `2px solid ${(config.borderColor ?? config.backgroundColor ?? '#007bff')}`,
                fontSize: `${String(config.fontSize ?? size ?? 16)}px`,
                fontFamily: (config.font ?? font),
                fontWeight: (config.bold ?? bold) ? 'bold' : 'normal',
                fontStyle: (config.italic ?? italic) ? 'italic' : 'normal',
                textDecoration: (config.underline ?? underline) ? 'underline' : 'none',
                padding: '5px 12px',
                borderRadius: '7px',
                cursor: 'pointer'
              }}
              onClick={() =>
                handleAction(
                  normalizeActionType(actionType),
                  config.linkUrl,
                  config       // ✅ pass full config
                )
              }
            >
              {(config.label ?? label ?? 'Submit')}
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  if (!page && testError) return <div role="alert">{testError} <a href="/login">Sign in</a></div>;
  if (!page) return <div>Loading...</div>;
  const visibleBlocks = Array.isArray(page?.blocks)
    ? page.blocks.filter(b => (b.step ?? 1) === currentStep)
    : [];



  return (
    <div
      className="mobile-live"
      style={{
        backgroundColor: page.backgroundColor || '#fff',
        color: page.color || '#000',
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
        padding: 10,
        boxSizing: 'border-box',
        opacity: pageFade ? 0 : 1,
        transition: 'opacity 0.15s ease'
      }}
    >
      {!testMode && captureReceived && <div role="status">Submission received. Printing is disabled for this Action.</div>}
      {testMode && <div role="status" style={{padding:10,background:'#fff3cd',color:'#222'}}>
        <strong>Landing Page test: no printing</strong>
        <div>Test submissions are stored separately from production records.</div>
        {testReceipt && <div>Test submission received. Receipt: {testReceipt}</div>}
        {testError && <div role="alert">{testError}</div>}
      </div>}
      {gameContext?.clue && (
        <div style={{
          padding: 10,
          background: '#111',
          color: '#fff',
          textAlign: 'center',
          marginBottom: 10
        }}>
          {gameContext.clue.revealText}
        </div>
      )}

      {visibleBlocks.map((block, index) =>
      renderBlock(block, index)
      )}
      {uploading && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 2000,
          background: 'rgba(0,0,0,0.55)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 20
        }}>
          <div style={{
            width: 'min(420px, 92vw)',
            background: '#111',
            borderRadius: 14,
            padding: 16,
            color: '#fff',
            boxShadow: '0 10px 30px rgba(0,0,0,0.45)'
          }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 10 }}>
              Uploading {captureSession.mode === 'video' ? 'video' : 'photo'}…
            </div>
            <div style={{ height: 10, background: '#333', borderRadius: 999 }}>
              <div style={{ height: 10, width: `${uploadProgress}%`, background: '#22c55e', borderRadius: 999 }} />
            </div>
            <div style={{ marginTop: 8, fontSize: 13, opacity: 0.9 }}>
              {uploadProgress}%
            </div>
          </div>
        </div>
      )}

      {captureSession.status === 'capturing' && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'black' }}>
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />

           {/* PHOTO */}
           {captureSession.mode === 'photo' && (
             <>
             <label className="photo-upload-control">Choose Photo<input type="file" accept="image/jpeg,image/png,image/webp" onChange={choosePhoto}/></label>
             <button
                onClick={runCaptureFlow}
                disabled={!frameReady || captureSession.status !== 'capturing'}
                style={{
                 position: 'absolute',
                 bottom: 24,
                 left: '50%',
                 transform: 'translateX(-50%)',
                 opacity: frameReady ? 1 : 0.5,
                 pointerEvents: frameReady ? 'auto' : 'none',
                 padding: '14px 24px',
                 fontSize: 18,
                 borderRadius: 30,
                 border: 'none',
                 background: '#2563eb',
                 color: '#fff',
                 fontWeight: 600,
                 boxShadow: '0 6px 20px rgba(0,0,0,0.35)',
                 cursor: 'pointer'
               }}
             >
               📸 Capture Photo
             </button>
             <button
               onClick={toggleCamera}
               aria-label="Switch camera"
               style={{
                 position: 'absolute',
                 bottom: 100,
                 right: 20,
                 zIndex: 1001,
                 background: 'rgba(0,0,0,0.5)',
                 color: '#fff',
                 border: 'none',
                 borderRadius: '50%',
                 width: 44,
                 height: 44,
                 fontSize: 18
               }}
             >
               🔄
             </button>
              </>
           )}

           {/* VIDEO */}
           {captureSession.mode === 'video' && !recording && (
             <>
             <button
               onClick={handleStartVideo}
               style={{
                 position: 'absolute',
                 bottom: 24,
                 left: '50%',
                 transform: 'translateX(-50%)',
                 padding: '14px 24px',
                 fontSize: 18,
                 borderRadius: 30,
                 border: 'none',
                 background: '#dc2626',
                 color: '#fff',
                 fontWeight: 600,
                 boxShadow: '0 6px 20px rgba(0,0,0,0.35)',
                 cursor: 'pointer'
               }}
             >
               ⏺ Start Recording
             </button>
             <button
               onClick={toggleCamera}
               style={{
                 position: 'absolute',
                 bottom: 100,
                 right: 20,
                 zIndex: 1001,
                 background: 'rgba(0,0,0,0.5)',
                 color: '#fff',
                 border: 'none',
                 borderRadius: '50%',
                 width: 44,
                 height: 44,
                 fontSize: 18
               }}
             >
               🔄
             </button>
              </>
           )}

           {captureSession.mode === 'video' && recording && (
             <button
               onClick={handleStopVideo}
               style={{
                 position: 'absolute',
                 bottom: 24,
                 left: '50%',
                 transform: 'translateX(-50%)',
                 padding: '12px 22px',
                 fontSize: 16,
                 borderRadius: 30,
                 border: 'none',
                 background: '#111',
                 color: '#fff',
                 fontWeight: 600,
                 boxShadow: '0 6px 20px rgba(0,0,0,0.4)',
                 cursor: 'pointer'
               }}
             >
               ⛔ Stop
             </button>
           )}

           {/* countdown (top-right) */}
           {recording && secondsLeft !== null && (
             <div style={{
               position: 'absolute',
               top: 16,
               right: 16,
               background: 'rgba(0,0,0,0.6)',
               color: '#fff',
               padding: '6px 12px',
               borderRadius: 10,
               fontSize: 18,
               fontWeight: 700
             }}>
               ⏺ {secondsLeft}s
             </div>
           )}
        </div>
      )}
      {captureSession.status === 'preview' && previewBlob && previewUrl && (
        <div className="capture-preview">
        {captureSession.mode === 'photo' && photoNeedsPositioning && (
            <PhotoCropper
              photoUrl={previewUrl}
              cardDesign={selectedCardDesign}
              faceFinder={FACE_FINDER_AVAILABLE && captureSession.faceFinder === true}
              onCropChange={handleCropChange}
              onReadyChange={handleCropReadyChange}
            />
        )}

          {captureSession.mode === 'photo' && !photoNeedsPositioning && <img src={previewUrl} alt="Captured photo" style={{maxWidth:'90vw',maxHeight:'65vh',objectFit:'contain'}}/>}
          {captureSession.mode === 'video' && (
            <video
              src={previewUrl}
              controls
              style={{
                maxWidth: '90vw',
                maxHeight: '65vh',
                borderRadius: 16
              }}
            />
          )}

          <div className="capture-preview-actions">
            <button
              onClick={retakePhoto}
              disabled={uploading}
              style={{
                padding: '12px 24px',
                borderRadius: 25,
                border: 'none',
                background: '#444',
                color: '#fff',
                fontWeight: 600
              }}
            >
              Retake
            </button>

            <button
              onClick={confirmPreview}
              disabled={uploading || (captureSession.mode === 'photo' && photoNeedsPositioning && !photoCropReady)}
              style={{
                padding: '12px 24px',
                borderRadius: 25,
                border: 'none',
                background: '#16a34a',
                color: '#fff',
                fontWeight: 600
              }}
            >
              {captureSession.mode === 'photo' ? 'Accept Photo' : 'Confirm'}
            </button>
          </div>

        </div>
      )}
    </div>
  );
};

export default MobileLandingPage;
